import { Suspense, lazy } from 'react';
import { Outlet } from 'react-router-dom';
// auth
import { AuthGuard } from 'src/auth/guard';
// layouts
import DashboardLayout from 'src/layouts/dashboard';
// components
import { LoadingScreen, SplashScreen } from 'src/components/loading-screen';

// ----------------------------------------------------------------------

// USER
const UserListPage = lazy(() => import('src/pages/dashboard/user/list'));
const UserAccountPage = lazy(() => import('src/pages/dashboard/user/account'));
const UserProfilePage = lazy(() => import('src/pages/dashboard/user/profile'));
// Chat
const ChatPage = lazy(() => import('src/pages/dashboard/chat'));

// ----------------------------------------------------------------------

export const dashboardRoutes = [
  {
    path: 'dashboard',
    element: (
      <AuthGuard>
        <DashboardLayout>
          <Suspense fallback={<SplashScreen />}>
            <Outlet />
          </Suspense>
        </DashboardLayout>
      </AuthGuard>
    ),
    children: [
      {
        path: 'user',
        children: [
          { element: <UserListPage />, index: true },
          { path: 'list', element: <UserListPage /> },
          { path: 'account', element: <UserAccountPage /> },
          { path: 'profile', element: <UserProfilePage /> },
        ],
      },
      // { path: 'chat', element: <ChatPage /> },
    ],
  },
  {
    path: 'chatbot',
    element: (
      <AuthGuard>
        <Suspense fallback={<SplashScreen />}>
          <ChatPage />
        </Suspense>
      </AuthGuard>
    ),
  },
];
